import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Leaf, LogOut } from "lucide-react";
import { toast } from "sonner";

export default function DashboardShell({ title, roleColor = "#059669", roleLabel, children, headerRight }) {
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const doLogout = () => { logout(); toast.success("Logged out"); nav("/login"); };

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/90 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-3 sm:px-6">
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="Grofkart" className="h-7 w-auto" />
            {roleLabel && <span className="rounded-md px-1.5 py-0.5 text-[10px] font-bold uppercase text-white" style={{ background: roleColor }}>{roleLabel}</span>}
          </div>
          <div className="ml-auto flex items-center gap-3">
            {headerRight}
            <span className="hidden text-sm font-medium text-slate-600 sm:block">{user?.name}</span>
            <button onClick={doLogout} data-testid="dash-logout-btn" className="flex items-center gap-1.5 rounded-xl border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-50">
              <LogOut className="h-4 w-4" /> <span className="hidden sm:block">Logout</span>
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
        <h1 className="mb-6 font-head text-2xl font-extrabold text-slate-900 sm:text-3xl">{title}</h1>
        {children}
      </main>
    </div>
  );
}

export function StatCard({ label, value, icon: Icon, color = "#059669", testid }) {
  return (
    <div data-testid={testid} className="rounded-2xl border border-slate-200 bg-white p-4">
      <div className="flex items-center justify-between">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">{label}</p>
        {Icon && <div className="flex h-8 w-8 items-center justify-center rounded-lg" style={{ background: `${color}18`, color }}><Icon className="h-4 w-4" /></div>}
      </div>
      <p className="mt-2 font-head text-2xl font-black text-slate-900">{value}</p>
    </div>
  );
}
